<div class="row">
    <div class="col-12">
        <button *ngFor="let mkt of markets" class="btn btn-primary btn-sm m-1"
                (click)="selMarket(mkt)">{{mkt.market}}</button>
    </div>
</div>
